import React from 'react'
import warningError from '../../../../assets/icons/u_warning-blue.svg'
import searchBarError from '../../../../assets/icons/search-bar-empty-error.svg';
import './FiltersErrorMessage.scss'
import { useTranslation } from 'react-i18next';

interface Props {
  isTable?: boolean;
}

const FiltersErrorMessage: React.FC<Props> = ({ isTable = false }) => {

  const { t } = useTranslation();

  return (
    <div className='contentFilterError'>
      {isTable ? (
        <div>
          <img src={searchBarError} alt="img-search-error" />
        </div>
      ) : (
        <div className='img-warning'>
          <img src={warningError} alt="img-warning-error" />
        </div>
      )}


      <div>
        <p className='title-error'>{t('title_error_filters')}</p>
        <p className='description-error'>{t('desc_error_filters')}</p>
      </div>
    </div>
  )
}

export default FiltersErrorMessage